<ng-container>
  <div class="wrapper wrapper-normal-height">
    <div class="custom-swiper">
      <swiper [spaceBetween]="15" [navigation]="true" [slidesPerView]="2" [scrollbar]="{ draggable: false }">
        <ng-template *ngFor="let asset of filterItemsOfActive(); index as i" swiperSlide let-data>
          <div fxLayoutAlign="end" *ngIf="isClose">
            <span class="remove-text" (click)="assetPanelRemoval(asset)"
              [ngClass]="{'remove-text': !asset.isPrimaryItem || enableRemoveBtn, 'remove-text-disable': asset.isPrimaryItem && !enableRemoveBtn }">
              Remove
            </span>
          </div>
          <div class="asset-panel ap-normal-height {{asset.isHighlightedItem ? 'ap-highlight': ''}}"
            (click)="assetPanelHighlight(asset)">
            <div class="panel-img" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="paneldesc pd-normal" fxLayoutAlign="start center">
                <span>
                  {{i+1}}&nbsp;{{asset.isAssetUnverified ? 'UV' : asset.isAssetNotApplicable ? 'NA' : ''}}&nbsp;
                </span>
                <span *ngIf="asset.isPrimaryItem">
                  <img class="flg-icon" src="assets/images/flag-red.svg" alt="Primary" tooltipClass="tooltipInfo"
                    placement="right" [ngbTooltip]="tipContent" />
                  <ng-template #tipContent> Primary Equipment </ng-template>
                </span>
                <span *ngIf="!asset.isPrimaryItem" (click)="assetPanelPrimaryFlag(asset)">
                  <img class="flg-icon" src="assets/images/flag-grey.svg" alt="Non Primary" tooltipClass="tooltipInfo"
                    placement="right" [ngbTooltip]="tipContent" />
                  <ng-template #tipContent> Make this as Primary Equipment </ng-template>
                </span>
                &nbsp;
                <span *ngIf="asset.goldenAssetInd === 'Y'">
                  <img class="flg-icon" src="assets/images/asset-golden.svg" alt="Golden" tooltipClass="tooltipInfo"
                    placement="right" [ngbTooltip]="tipContent" />
                  <ng-template #tipContent> Golden Asset </ng-template>
                </span>
              </div>
              <div class="panel-status" *ngIf="(!asset.isNotApplicableItem && !asset.isUnverifiedItem)">
                {{asset.equipmentStatus}}
              </div>
            </div>
            <div *ngIf="(!asset.isNotApplicableItem && !asset.isUnverifiedItem)">
              <div class="pd-space"></div>
              <div class="panelEqno">EQUIP. NO. {{asset.signalBoxEqNo}}</div>
              <div class="pd-space"></div>
              <div class="paneldesc pd-bold">
                {{asset.equipmentDescription?.length > 0 ? asset.equipmentDescription : ''}}
              </div>
              <div class="paneldesc1">{{asset.localName}}</div>
              <div class="pd-space"></div>
              <div class="paneldesc2">{{asset.itemClass}} - {{asset.itemType}}</div>
              <div class="paneldesc pd-normal panelElr">
                {{asset.elr?.length > 0 ? asset.elr : ''}}&nbsp;
                :&nbsp;{{getMileageDisplayValue(asset.startYardageLimit)}}&nbsp;
                :&nbsp;{{getMileageDisplayValue(asset.endYardageLimit)}}&nbsp;&nbsp;&nbsp;
                Track ID:&nbsp;{{asset.trackId}}
              </div>
            </div>
            <div *ngIf="(asset.isNotApplicableItem || asset.isUnverifiedItem)">
              <div class="paneldesc pd-comments">{{asset.calculatedDesc}}</div>
              <div class="pd-space"></div>
              <div class="paneldesc pd-normal">Place:&nbsp;<strong>{{asset.placeName}}</strong></div>
              <div class="paneldesc pd-normal">Discipline:&nbsp;<strong>{{asset.discipline}}</strong></div>
              <div class="paneldesc pd-normal">Suffix:&nbsp;<strong>{{asset.suffixName}}</strong></div>
            </div>
          </div>
        </ng-template>
      </swiper>
    </div>
  </div>
</ng-container>